import { Grid2 } from "@mui/material";
import { useDispatch } from "react-redux";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";
import { defaultRadioSelect } from "../../../../UI/GeneralPurpose/genericIDs";
import { citySelectUI } from "./Form/Components/AddressInfo/City";
import { deliveryOfficeUI } from "./Form/Components/AddressInfo/DeliveryOffice";
import { deliveryStreetUI } from "./Form/Components/AddressInfo/DeliveryStreet";
import { deliveryStreetNumberUI } from "./Form/Components/AddressInfo/DeliveryStreetNumber";
import { districtSelectUI } from "./Form/Components/AddressInfo/District";
import { regionSelectUI } from "./Form/Components/AddressInfo/Region";
import { contactEmailUI } from "./Form/Components/ContactInfo/ContactEmail";
import { contactNameUI } from "./Form/Components/ContactInfo/ContactName";
import { contactPhoneUI } from "./Form/Components/ContactInfo/ContactPhone";
import { encryptData } from "./Form/Components/DeliveryMode/DeliveryMode";
import { deliveryWindowFromUI, deliveryWindowToUI } from "./Form/Components/DeliveryWindow";
import { otherReasonUI } from "./Form/Components/Reason/OtherReason";
import { reasonUI } from "./Form/Components/Reason/Reasons";
import { miscErrorsUI } from "./Next";

const UIText = {
  "es-CL": { label: "Resetear formulario" },
  "en-US": { label: "Reset form" },
};

const Reset = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(UIactions.clear(contactNameUI));
    dispatch(UIactions.clear(contactPhoneUI));
    dispatch(UIactions.clear(contactEmailUI));
    dispatch(UIactions.clear(deliveryOfficeUI));
    dispatch(UIactions.clear(deliveryStreetUI));
    dispatch(UIactions.clear(deliveryStreetNumberUI));
    dispatch(UIactions.clear(regionSelectUI));
    dispatch(UIactions.clear(districtSelectUI));
    dispatch(UIactions.clear(citySelectUI));
    dispatch(UIactions.clear(deliveryWindowFromUI));
    dispatch(UIactions.clear(deliveryWindowToUI));
    dispatch(UIactions.clear(otherReasonUI));
    dispatch(UIactions.clear(reasonUI));
    dispatch(UIactions.clear(encryptData));
    dispatch(UIactions.clear(miscErrorsUI));
    dispatch(UIactions.setValue({ id: defaultRadioSelect, value: "link" }));
  };

  return (
    <Grid2 container size={4} justifyContent="center">
      <Button {...{ UIText, onClick: handleClick, variant: "outlined" }} />
    </Grid2>
  );
};

export default Reset;
